import { imageTypes, videoTypes } from '../components/config-v2';

/**
 * 图片类型
 * @description saas、console-pc、store-h5 对齐
 *  注意：这里不复用 @/common/components/config-v2 的 imageTypes，
 *  因为 config-v2 的常量被 V2FormUpload / V2UploadFile / V2UploadDragger 等大量上传/预览组件使用，
 *  其视频白名单受 videojs 黑屏问题限制只列了 4 项；此处仅服务于"动态表单上传分类"的判定，单独维护互不影响。
 */
export const IMAGE_TYPES = Array.from(new Set([...imageTypes, 'png', 'jpg', 'gif', 'jpeg', 'bmp', 'webp', 'heic']));

/**
 * 视频类型
 * @description saas、console-pc、store-h5 对齐
 */
export const VIDEO_TYPES = Array.from(new Set([...videoTypes,
  'rm', 'rmvb', 'mpeg1-4', 'mov', 'mtv', 'dat', 'wmv', 'avi',
  '3gp', 'amv', 'dmv', 'flv', 'mp4', 'dwg', 'm3u8',
  'm2v', 'mkv', 'm4v',
]));
